import { Popover } from '@base-ui/react/popover'
import type { PartProps } from '../../../lib/part-props'

interface PopoverPortalProps extends PartProps<Popover.Portal.Props> {}

function PopoverPortal({ children, ...props }: PopoverPortalProps) {
  return <Popover.Portal {...props}>{children}</Popover.Portal>
}

export { PopoverPortal }
